import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { DEFAULT_PLACEMENT_OPTIONS, MINIMUM_SCREEN_GUTTER } from './Flyout.constants.js';

var calculateLeftPosition = function calculateLeftPosition(_ref) {
  var placement = _ref.placement,
    offset = _ref.offset,
    container = _ref.container,
    triggerPosition = _ref.triggerPosition;
  var triggerLeft = triggerPosition.left,
    triggerWidth = triggerPosition.width;
  switch (placement) {
    case 'bottom-end':
    case 'top-end':
      return Math.round(triggerLeft + triggerWidth - container.width - offset);
    case 'right-start':
    case 'right-end':
    case 'right-center':
      return Math.round(triggerLeft + triggerWidth - offset);
    case 'top-centre':
    case 'bottom-centre':
      return Math.round(triggerLeft + triggerWidth / 2 - container.width / 2);
    default:
      return Math.round(triggerLeft - offset);
  }
};
var calculateTopPosition = function calculateTopPosition(_ref2) {
  var placement = _ref2.placement,
    triggerPosition = _ref2.triggerPosition,
    offset = _ref2.offset,
    container = _ref2.container;
  var triggerTop = triggerPosition.top,
    triggerHeight = triggerPosition.height;
  switch (placement) {
    case 'left-end':
    case 'right-end':
      return Math.round(triggerTop + triggerHeight + offset - container.height);
    case 'bottom-start':
    case 'bottom-end':
    case 'bottom-centre':
      return Math.round(triggerTop + triggerHeight + offset);
    case 'right-center':
    case 'left-centre':
      return Math.round(triggerTop + triggerHeight / 2 - container.height / 2);
    default:
      return Math.round(triggerTop + offset);
  }
};
var calculatedAdjustedOffScreenPosition = function calculatedAdjustedOffScreenPosition(_ref3) {
  var isOffscreenBottom = _ref3.isOffscreenBottom,
    isOffscreenTop = _ref3.isOffscreenTop,
    isOffscreenRight = _ref3.isOffscreenRight,
    isOffscreenLeft = _ref3.isOffscreenLeft,
    left = _ref3.left,
    top = _ref3.top,
    container = _ref3.container;
  var adjustedTop = top;
  var adjustedLeft = left;
  if (isOffscreenRight) {
    var calculatedNewLeft = window.innerWidth - container.width - MINIMUM_SCREEN_GUTTER;
    adjustedLeft = calculatedNewLeft < MINIMUM_SCREEN_GUTTER ? MINIMUM_SCREEN_GUTTER : calculatedNewLeft;
  }
  if (isOffscreenLeft) adjustedLeft = MINIMUM_SCREEN_GUTTER;
  if (isOffscreenBottom) {
    var calculatedNewTop = window.innerHeight - container.height - MINIMUM_SCREEN_GUTTER;
    adjustedTop = calculatedNewTop < MINIMUM_SCREEN_GUTTER ? MINIMUM_SCREEN_GUTTER : calculatedNewTop;
  }
  if (isOffscreenTop) adjustedTop = MINIMUM_SCREEN_GUTTER;
  return {
    left: adjustedLeft,
    top: adjustedTop
  };
};
var getCalculatedRelativePlacement = function getCalculatedRelativePlacement(_ref4) {
  var placement = _ref4.placement,
    offset = _ref4.offset,
    container = _ref4.container,
    isPortalAlwaysOnScreen = _ref4.isPortalAlwaysOnScreen,
    triggerPosition = _ref4.triggerPosition;
  var calculatedPositions = {
    left: MINIMUM_SCREEN_GUTTER,
    top: MINIMUM_SCREEN_GUTTER
  };
  var position = _objectSpread2({
    offset: offset
  }, DEFAULT_PLACEMENT_OPTIONS[placement]);
  if (!container) return calculatedPositions;
  var horizontalOffset = position !== null && position !== void 0 && position.isLeftOfTrigger ? container === null || container === void 0 ? void 0 : container.width : 0;
  var verticalOffset = position !== null && position !== void 0 && position.isAboveTrigger ? container === null || container === void 0 ? void 0 : container.height : 0;
  var top = calculateTopPosition({
    container: container,
    offset: (position.offset.top || 0) - verticalOffset,
    placement: placement,
    triggerPosition: triggerPosition
  });
  var left = calculateLeftPosition({
    container: container,
    offset: (position.offset.left || 0) + horizontalOffset,
    placement: placement,
    triggerPosition: triggerPosition
  });
  if (isPortalAlwaysOnScreen) {
    var isOffscreenTop = top <= MINIMUM_SCREEN_GUTTER;
    var isOffscreenBottom = top + container.height > window.innerHeight - MINIMUM_SCREEN_GUTTER;
    var isOffscreenLeft = left <= MINIMUM_SCREEN_GUTTER;
    var isOffscreenRight = left + container.width > window.innerWidth - MINIMUM_SCREEN_GUTTER;
    return calculatedAdjustedOffScreenPosition({
      container: container,
      isOffscreenBottom: isOffscreenBottom,
      isOffscreenLeft: isOffscreenLeft,
      isOffscreenRight: isOffscreenRight,
      isOffscreenTop: isOffscreenTop,
      left: left,
      top: top
    });
  }
  return {
    left: left,
    top: top
  };
};

export { calculateLeftPosition, calculateTopPosition, calculatedAdjustedOffScreenPosition, getCalculatedRelativePlacement };
//# sourceMappingURL=Flyout.helper.js.map
